/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Cancel_Edit_LabelInputs */



/**
* | output |
* | --- |
* | "Cancel editing" |
*
* @param {Manual_Qc_Cancel_Edit_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_cancel_edit_label = /** @type {((inputs?: Manual_Qc_Cancel_Edit_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Cancel_Edit_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler la modification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeitung abbrechen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменить редактирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar edición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("取消编辑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集をキャンセル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादन रद्द करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancelar edição")
	return /** @type {LocalizedString} */ ("Cancel editing")
});